<template>
  <div class="booked-tariff-options container" :class="bookedTariffoptions.length <= 1 ? 'options-grid' : ''">
    <div v-if="bookedTariffoptions.length > 0">
      <h2 class="text-3xl text-align-left">Meine Tarifoptionen</h2>
      <div :class="bookedTariffoptions.length > 1 ? 'options-grid' : ''">
        <div v-for="option in bookedTariffoptions" :key="option.tariffoptionId" class="container-box flex text-base">
          <TariffOptionsIcon :value="value (option)" />
          <p class="text-xl">{{ option.name }}</p>
          <div class="flex-row">
            <div>
              <h3 class="text-3xl">{{ (option.cardInformation && option.cardInformation.length) ? option.cardInformation[0].primary : '–' }}</h3>
              <p class="text-sm"> {{ (option.cardInformation && option.cardInformation.length) ? option.cardInformation[0].secondary : '–' }}</p>
            </div>
            <div>
              <h3 class="text-3xl">{{ option.formattedPrice }}</h3>
              <p class="text-sm">für {{ option.duration.amount }} {{ option.duration.formattedUnit }}</p>
            </div>
          </div>
          <p class="text-muted text-sm">{{ option.buttonText }}</p>
          <div class="btn-wrapper">
            <button
              v-if="deactivatable(option)"
              :disabled="loading"
              @click="deactivate(option)"
              class="button button--secondary"
            >
              Deaktivieren
            </button>
            <button class="button button--primary" @click="openModal(option)">Details anzeigen</button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div :class="bookedTariffoptions.length > 1 ? 'options-grid' : ''">
        <ServiceOptions :extraData="extraData"></ServiceOptions>
      </div>
    </div>

    <CustomModal :visible="showModal" @close="showModal = false" :showPrev="true" @prev="showModal = false">
      <template slot="header">
        <div class="details-header" v-if="selectedDetails">
          <TariffOptionsIcon :value="value (selectedDetails)" />
          <h3 class="text-3xl">
            {{ selectedDetails.name }}
          </h3>

          <div class="flex-row">
            <div>
              <h3 class="text-3xl">{{ (selectedDetails.cardInformation && selectedDetails.cardInformation.length) ? selectedDetails.cardInformation[0].primary : '–' }}</h3>
              <p class="text-sm">{{ (selectedDetails.cardInformation && selectedDetails.cardInformation.length) ? selectedDetails.cardInformation[0].secondary : '–' }}</p>
            </div>
            <div>
              <h3 class="text-3xl">{{ selectedDetails.formattedPrice }}</h3>
              <p class="text-sm">für {{ selectedDetails.duration.amount }} {{ selectedDetails.duration.formattedUnit }}</p>
            </div>
          </div>
        </div>
      </template>
      <template slot="default">
        <div class="text-base" v-if="selectedDetails" v-html="selectedDetails.details"></div>
      </template>
      <template slot="btnPrevTxt">
        <slot name="btnPrevTxt">Schließen</slot>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import TariffOptionsIcon from '../TariffOptions/TariffOptionsIcon.vue'
import ServiceOptions from '@/components-v2/generic/ServiceOptions.vue'
import CustomModal from '@/components/generic/CustomModal.vue'
import { mapActions, mapGetters } from 'vuex'
import extraData from '../../../../../../mixins/extraData'

export default {
  data() {
    return {
      tariffoptions: {
        bookedTariffoptions: {
          bookedTariffoptions: []
        }
      },
      showModal: false,
      selectedDetails: null,
      loading: false
    }
  },
  components: {
    TariffOptionsIcon,
    ServiceOptions,
    CustomModal
  },
  computed: {
    bookedTariffoptions() {
      return this.tariffoptions.bookedTariffoptions.bookedTariffoptions
    },
    doubleDataPromo: function() {
      return ['CCS_92055', 'CCS_92056', 'CCS_92057']
    },
    ...mapGetters('bookTariffOptions', ['bookTariffoptionDocumentUrl'])
  },
  mixins: [
    extraData()
  ],
  methods: {
    ...mapActions('bookTariffOptions', [
      'confirmTariffoption',
      'deactivateTariffOption',
      'cancelTariffOptionConfirm',
      'initiateCancelTariffOption'
    ]),
    value(option) {
      return option.cardInformation.length > 0 && option.cardInformation[0].iconText
        ? option.cardInformation[0].iconText
        : '-'
    },
    openModal(details) {
      this.selectedDetails = details
      this.showModal = true
    },
    deactivate(option) {
      if (this.loading) return

      this.loading = true

      const optionId = option.tariffoptionId
      if (
        option.automaticExtension === true &&
        option.cancelable === true &&
        option.statusKey !== 'TER' &&
        !this.doubleDataPromo.includes(optionId)
      ) {
        this.initiateCancelTariffOption({ tariffoptionId: optionId }).then(success => {
          if (success) {
            this.cancelTariffOptionConfirm().then(
              success => {
                if (success) {
                  this.$store.commit('addMessage', { type: 'success', message: 'Tarifoption erfolgreich gekündigt' })
                  this.$emit('refresh')
                }
                this.loading = false
              },
              () => {
                this.loading = false
              }
            )
          } else {
            this.loading = false
          }
        })
      } else {
        this.loading = false
      }
    },
    deactivatable(option) {
      return (
        option.__typename === 'BookedTariffoption' &&
        option.cancelable &&
        option.statusKey !== 'TER' &&
        !this.doubleDataPromo.includes(option.tariffoptionId)
      )
    }
  },
  apollo: {
    tariffoptions: function() {
      return wrapQuery(
        gql`
          query tariffOptions {
            tariffoptions {
              bookedTariffoptions {
                bookedTariffoptions {
                  bandwidth {
                    down
                    formattedUnit
                    up
                    unit
                  }
                  automaticExtension
                  expirationDate
                  tariffoptionId
                  stateFlag
                  statusKey
                  name
                  price
                  duration {
                    amount
                    unit
                    formattedUnit
                  }
                  details
                  statusKey
                  activeRuntime {
                    endOfRuntime
                    startOfRuntime
                  }
                  volumes {
                    amount
                    formattedUnit
                    type
                    unit
                  }
                  possibleChangingDate
                  buttonText
                  cancelable
                  formattedPrice
                  restrictedService
                  statusKey
                  flat
                  iconText
                  extraDataVolumes {
                    primary
                    secondary
                  }
                  extraDataDescription
                  possibleChangingDate
                  cardInformation {
                    primary
                    secondary
                    iconText
                  }
                }
              }
            }
          }
        `,
        this,
        'tariffoptions'
      )
    },
    serviceOptions: function() {
      return wrapQuery(
        gql`
          query serviceOptions {
            serviceOptions {
              anonymousCallRejection
            }
          }
        `,
        this,
        'serviceOptions'
      )
    },
    tariffs: function() {
      return wrapQuery(
        gql`
          query tariffs {
            tariffs {
              bookedTariff {
                tariffId
              }
            }
          }
        `,
        this,
        'tariffs'
      )
    }
  }
}
</script>
